/**
 * Дедуп телефона при создании аккаунта: GET /admin/clients/phone-check.
 * Возвращает ФИО владельца номера или null, если номер свободен.
 * Мок — прежний phoneOwner по MOCK_CLIENTS.
 */

import {apiEnabled, http} from '@services/utils';
import {toE164} from '@utils/phone';

import {phoneOwner} from '../refs';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const checkPhone = async (phone: string): Promise<string | null> => {
  if (!apiEnabled) {
    await sleep(180);
    // Мок сравнивает полные номера — приводим 9 цифр к E.164
    return phoneOwner(toE164(phone));
  }

  const raw = await http<{ownerName?: string | null}>('admin/clients/phone-check', {
    params: {phone: toE164(phone)},
    skipCaseConversion: true,
  });
  return typeof raw.ownerName === 'string' ? raw.ownerName : null;
};
